// extracted by mini-css-extract-plugin
export default {"content":"MxOoW","description":"YXanV","iconFallback":"l1y0o","examples":"_Xs76"};